(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class HeaderWrapper extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.shopify-section-header');

      this.exitTimer = null;
      this.onEnterHandler = this.onEnter.bind(this);
      this.onLeaveHandler = this.onLeave.bind(this);
      this.addEventListener('mouseenter', this.onEnterHandler);
      this.addEventListener('mouseleave', this.onLeaveHandler);
    }

    disconnectedCallback() {
      this.removeEventListener('mouseenter', this.onEnterHandler);
      this.removeEventListener('mouseleave', this.onLeaveHandler);
    }

    onEnter() {
      this.preventClose = true;
      this.header.classList.add('is-active');
      clearTimeout(this.exitTimer);
    }

    onLeave() {
      this.exitTimer = setTimeout(() => {
        this.header.classList.remove('is-active');
      }, 400);
    }

  }
  customElements.define('header-wrapper', HeaderWrapper);

  class StickyHeader extends HeaderWrapper {
    constructor() {
      super();
    }

    connectedCallback() {
      super.connectedCallback();

      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.scrollUpActive = false;
      this.isAtTop = false;

      this.suppressScrollUntil = 0;
      this.toggleBtn = this.querySelector('header-menu-toggle');
      this.toggleBtn?.addEventListener('click', () => {
        this.suppressScrollUntil = performance.now() + 250;
        this.header.classList.toggle('shopify-section-header-menu-open');
      });

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      window.addEventListener('scroll', this.onScrollHandler, false);
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);

      this.createObserver();
    }

    disconnectedCallback() {
      super.disconnectedCallback?.();

      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;

        if (this.headerBounds.top === 0 && this.headerBounds.bottom === 0) {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          const boundingClientRect = entries[0].boundingClientRect;

          this.headerBounds = {
            top: scrollTop + boundingClientRect.top,
            bottom: scrollTop + boundingClientRect.bottom
          };
        }

        if (this.dataset.scrollUp !== undefined) {
          this.scrollUpActive = true;
        }

        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      if (performance.now() < this.suppressScrollUntil) {
        this.currentScrollTop = window.pageYOffset || document.documentElement.scrollTop;
        return;
      }

      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (scrollTop <= 0) {
        this.header.classList.remove('shopify-section-header-sticky');
        document.body.classList.remove('shopify-body-section-header-sticky');
        this.isAtTop = true;
        this.currentScrollTop = scrollTop;
        return;
      }
      if (this.isAtTop && scrollTop > 10) {
        this.isAtTop = false;
      }
      if (this.isAtTop) {
        this.currentScrollTop = scrollTop;
        return;
      }

      if (theme.config.mqlSmall || this.scrollUpActive) {
        if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          requestAnimationFrame(this.hide.bind(this));
        }
        else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          if (!this.preventReveal) {
            requestAnimationFrame(this.reveal.bind(this));
          }
          else {
            window.clearTimeout(this.isScrolling);

            this.isScrolling = setTimeout(() => {
              this.preventReveal = false;
            }, 66);

            requestAnimationFrame(this.hide.bind(this));
          }
        }
        else if (scrollTop <= this.headerBounds.top) {
          requestAnimationFrame(this.reset.bind(this));
        }
      }
      else {
        if (scrollTop > this.headerBounds.bottom) {
          if (this.sticky()) return;
          
          requestAnimationFrame(this.hide.bind(this));

          setTimeout(() => {
            requestAnimationFrame(this.reveal.bind(this));
          }, 300);
        }
        else if (scrollTop <= this.headerBounds.top) {
          requestAnimationFrame(this.reset.bind(this));
        }
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.isAtTop) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      document.body.classList.add('shopify-body-section-header-hidden', 'shopify-body-section-header-sticky');
    }

    reveal() {
      if (this.isAtTop) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
      document.body.classList.add('shopify-body-section-header-sticky');
      document.body.classList.remove('shopify-body-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    sticky() {
      return this.header.classList.contains('shopify-section-header-sticky') && !this.header.classList.contains('shopify-section-header-hidden') && document.body.classList.contains('shopify-body-section-header-sticky') && !document.body.classList.contains('shopify-body-section-header-hidden');
    }
  }
  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["roverie-podcast"] && !Shopify.designMode) return;
  try {
    
function initRoveriePodcast(root) {
  if (root.dataset.ready) return;
  root.dataset.ready = 'true';
  const track = root.querySelector('.rvpod__track');
  const arrows = root.querySelector('.rvpod__arrows');
  const buttons = arrows.querySelectorAll('button');
  const updateArrows = () => {
    const overflow = track.scrollWidth > track.clientWidth + 3;
    arrows.hidden = !overflow;
    buttons[0].disabled = track.scrollLeft <= 2;
    buttons[1].disabled = track.scrollLeft >= track.scrollWidth - track.clientWidth - 3;
  };
  buttons.forEach(button => button.addEventListener('click', () => {
    const card = track.querySelector('li');
    if (!card) return;
    const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
    track.scrollBy({ left: (card.getBoundingClientRect().width + gap) * Number(button.dataset.direction), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
  }));
  track.addEventListener('scroll', updateArrows, { passive: true });
  new ResizeObserver(updateArrows).observe(track);
  updateArrows();
  const details = root.querySelector('[data-player]');
  details.addEventListener('toggle', () => {
    const holder = details.querySelector('[data-player-frame]');
    if (!details.open || holder.children.length) return;
    const frame = document.createElement('iframe');
    frame.src = holder.dataset.src;
    frame.title = holder.dataset.title;
    frame.allow = 'autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture';
    frame.loading = 'lazy';
    holder.append(frame);
  });
  const feed = root.dataset.feed;
  if (!feed) return;
  const safeURL = value => {
    try { const url = new URL(value); return url.protocol === 'https:' ? url.href : ''; } catch { return ''; }
  };
  async function refreshEpisodes() {
    if (!root.isConnected) return;
    try {
      const response = await fetch(feed, { credentials: 'omit', signal: AbortSignal.timeout(10000) });
      if (!response.ok) throw new Error('Feed unavailable');
      const xml = new DOMParser().parseFromString(await response.text(), 'application/xml');
      if (xml.querySelector('parsererror')) throw new Error('Invalid feed');
      const episodes = [...xml.querySelectorAll('item')].map(item => {
        const nodes = [...item.children];
        const text = name => nodes.find(node => node.localName === name)?.textContent?.trim() || '';
        const links = nodes.filter(node => /link|url|guid/.test(node.localName)).map(node => node.getAttribute('href') || node.textContent.trim());
        const spotify = links.find(link => /^https:\/\/open\.spotify\.com\/episode\//.test(link));
        return { title: text('title'), url: safeURL(spotify || text('link')), date: Date.parse(text('pubDate')), image: safeURL(nodes.find(node => node.localName === 'image')?.getAttribute('href') || root.dataset.cover) };
      }).filter(item => item.title && item.url && (!Number.isFinite(item.date) || item.date <= Date.now())).sort((a,b) => (b.date || 0) - (a.date || 0)).slice(0,12);
      if (!episodes.length) return;
      const fragment = document.createDocumentFragment();
      episodes.forEach((episode,index) => {
        const li = document.createElement('li'); li.className = 'rvpod__episode';
        const img = document.createElement('img'); img.className = 'rvpod__cover'; img.src = episode.image || root.dataset.cover; img.alt = ''; img.loading = 'lazy'; img.width = 72; img.height = 72;
        const copy = document.createElement('div');
        const date = document.createElement('p'); date.className = 'rvpod__episode-date';
        date.textContent = (index === 0 ? root.dataset.latest + ' · ' : '') + (Number.isFinite(episode.date) ? new Intl.DateTimeFormat(root.dataset.locale || 'de', { dateStyle: 'medium' }).format(episode.date) : '');
        const heading = document.createElement('h3'); const title = document.createElement('a'); title.textContent = episode.title; title.href = episode.url; title.target = '_blank'; title.rel = 'noopener'; heading.append(title);
        const link = document.createElement('a'); link.className = 'rvpod__episode-link'; link.href = episode.url; link.target = '_blank'; link.rel = 'noopener'; link.textContent = root.dataset.listen + ' ↗';
        copy.append(date,heading,link); li.append(img,copy); fragment.append(li);
      });
      track.replaceChildren(fragment); track.scrollLeft = 0; updateArrows();
    } catch { }
  }
  refreshEpisodes();
  const interval = setInterval(() => { if (!root.isConnected) clearInterval(interval); else if (!document.hidden) refreshEpisodes(); }, 900000);
}
document.querySelectorAll('.rvpod').forEach(initRoveriePodcast);
document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('.rvpod').forEach(initRoveriePodcast));

  } catch(e) { console.error(e); }
})();
})();
